export default function ToolWorkspace({ config, configTitle, configDescription, output, outputTitle, outputActions, full = false }) {
  return (
    <div className={`dt-workspace${full ? ' is-full' : ''}`}>
      {!full && (
        <section className="dt-card dt-workspace-config" aria-label={configTitle || 'Configuration'}>
          {configTitle && (
            <div className="dt-workspace-config-head">
              <h2 className="dt-section-title">{configTitle}</h2>
              {configDescription && <p className="dt-support">{configDescription}</p>}
            </div>
          )}
          {config}
        </section>
      )}
      <section className={`dt-card dt-workspace-output${full ? ' is-full' : ''}`} aria-label={outputTitle || 'Output'}>
        {(outputTitle || outputActions) && (
          <div className="dt-workspace-output-head">
            <h2 className="dt-section-title">{outputTitle}</h2>
            {outputActions && <div className="dt-workspace-output-actions">{outputActions}</div>}
          </div>
        )}
        {output}
      </section>
    </div>
  );
}
